var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevVi1 = function SvgDevVi1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#025231",
    fillRule: "evenodd",
    d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
    clipRule: "evenodd"
  })));
};
export default SvgDevVi1;